<template>
  <Accordion
    :Heading="customSettings"
    :Title3="Title"
    :customSettingToggleValue="customSettingToggleValue"
    :customSettingFlag="true"
    :defaultExpanded="$route.query.expandSections === 'true'"
  >
    <div>
      <AddCustomSetting
        v-if="showCreatePopup"
        :showCreatePopup="showCreatePopup"
        :duplicateCustomSettingId="duplicateCustomSettingId"
        @visibleDialog="showCreatePopup = false"
        @getCustomSettingId="setNewCustomSetting"
        @getCustomSettingsData="loadGrid"
        @save="handleSave"
      ></AddCustomSetting>

      <EditCustomSetting
        v-if="showEditPopup"
        :showEditPopup="showEditPopup"
        :customSettingId="customSettingId"
        :seamUnitDefaultValue="seamUnitDefaultValue"
        :seamLengthUnit="seamLengthUnit"
        @visibleEditDialog="showEditPopup = false"
        @getCustomSettingsData="loadGrid"
        @editSave="handleEditSave"
      ></EditCustomSetting>
      <div v-if="+(activeUserId ?? 0) == 101" class="toggleComp">
        <div class="customSetting">{{ Title }} :</div>
        <div class="toggle">
          <toggle-button
            :height="25"
            :width="60"
            checkedText="On"
            uncheckedText="Off"
            checkedBg=" #0054a6"
            uncheckedBg="lightgrey"
            v-model="toggleButtonVal"
            @click="onToggleChange(toggleButtonVal)"
          ></toggle-button>
        </div>
      </div>
      <div class="card bg-white mb-3" style="width: 100%; border-radius: 10px">
        <div class="card-body">
          <button
            v-if="showButtons"
            class="btn btn-sm btn-primary mb-3"
            style="float: right; border-radius: 4px; width: 11em; background-color: #0054a6; color: white"
            @click="showAddCustomSetting"
          >
            <span class="k-icon k-i-plus iconStyle" style="margin-right: 5px"></span>{{ $t("customSetting.addNew") }}
          </button>
          <div class="inputs">
            <div v-if="loadingGrid">
              <template>
                <GridLoading></GridLoading>
              </template>
            </div>
            <div v-else class="Grid">
              <kendo-grid
                ref="settingGrid"
                :data-source="dataSource"
                :columns="columns"
                :sortable="true"
                :column-menu="true"
                :filterable="true"
                :reorderable="true"
                :scrollable-endless="true"
                :selectable="'multiple'"
                :persistSelection="true"
                :selected-field="selectedField"
              >
              </kendo-grid>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Accordion>
  <BModalOrchestrator></BModalOrchestrator>
</template>
<script lang="ts">
import { Grid } from "@progress/kendo-grid-vue-wrapper";
import Accordion from "@/app/views/_components/Accordion.vue";
import AddCustomSetting from "@/app/views/_components/AddCustomSetting.vue";
import EditCustomSetting from "@/app/views/_components/EditCustomSetting.vue";
import GridLoading from "@/app/views/_components/GridLoading.vue";
import { UserAdminSettingApi, CustomSettingsApi } from "@/api";
import { ConfigurationUpdateDto } from "@/api/model";
import { defineComponent } from "vue";
import { useToast } from "vue-toastification";
import VueToggles from "vue-toggles";
import { useModalController, BModalOrchestrator } from "bootstrap-vue-next";

export default defineComponent({
  name: "CustomSettings",
  components: {
    "kendo-grid": Grid,
    Accordion,
    AddCustomSetting,
    "toggle-button": VueToggles,
    EditCustomSetting,
    GridLoading,
    BModalOrchestrator
  },
  props: {
    seamUnitDefaultValue: null as any,
    seamLengthUnit: null as any
  },
  emits: ["onToggleChange"],
  setup() {
    const userAdminSettingApi = new UserAdminSettingApi()!;
    const customSettingsApi = new CustomSettingsApi()!;
    const { confirm } = useModalController();
    const confirmModal = (title: any, modalcontent: any): Promise<any> | any => {
      return confirm?.({
        props: {
          title: title,
          body: modalcontent,
          size: "md",
          buttonSize: "sm",
          okVariant: "danger",
          headerClass: "p-2",
          footerClass: "p-2",
          centered: true
        }
      });
    };
    return {
      userAdminSettingApi,
      customSettingsApi,
      confirm,
      confirmModal
    };
  },
  data() {
    return {
      activeUserId: sessionStorage.getItem("activeUserId"),
      Title: this.$t("customSetting.editCustomSetting"),
      customSettings: this.$t("customSetting.customSettings"),
      toggleButtonVal: (sessionStorage.getItem("customSettingToggleValue") == "true") as any,
      customSettingToggleValue: "" as any,
      showButtons: false,
      showCreatePopup: false,
      showEditPopup: false,
      customSettingId: null as any,
      duplicateCustomSettingId: null as any,
      loadingGrid: false,
      selectedField: "selected" as any,
      enable: this.$t("customSetting.enable"),
      disable: this.$t("customSetting.disable"),
      customSettingData: Object as any,
      abc: false,
      columns: [] as any,
      columns1: [
        { field: "id", title: "", width: "50px", hidden: true },
        { field: "name", title: this.$t("customSetting.settingName"), width: "50px" },
        { field: "tktTex", title: this.$t("customSetting.tktTex"), width: "40px" },
        { field: "defaultAllowance", title: this.$t("customSetting.allowance") + " %", width: "50px" },
        { field: "creationTime", title: this.$t("customSetting.dateCreated"), width: "50px" },
        { field: "createdBy", title: this.$t("customSetting.createdBy"), width: "50px" },
        { field: "lastModificationTime", title: this.$t("customSetting.lastEdited"), width: "50px" },
        { field: "lastModifiedBy", title: this.$t("customSetting.editedBy"), width: "50px" },
        {
          field: "id",
          command: [
            {
              template:
                `<a role=button class='k-button k-button-icontext k-grid-editStyle' style="border-radius: 3px;
                  border-style: none;"><span class="fas fa-edit" title="` +
                "Edit" +
                `"></span></a>`,
              name: "editStyle",
              text: "",
              click: this.editStyle
            },
            {
              template:
                `<a role=button class='k-button k-button-icontext k-grid-duplicateStyle' style="border-radius: 3px;
                  border-style: none;"><span class="far fa-clone" title="` +
                "clone" +
                `"></span></a>`,
              name: "duplicateStyle",
              text: " ",
              click: this.duplicateStyle
            },
            {
              template:
                `<a role=button class='k-button k-button-icontext k-grid-deleteStyle' style="border-radius: 3px;
                  border-style: none;"><span class='fa fa-trash' title="` +
                "delete" +
                `"></span></a>`,
              name: "deleteStyle",
              text: " ",
              click: this.deleteStyle
            }
          ],
          title: this.$t("customSetting.action"),
          width: "70px"
        }
      ],
      columns2: [
        { field: "id", title: "", width: "50px", hidden: true },
        { field: "name", title: this.$t("customSetting.settingName"), width: "50px" },
        { field: "tktTex", title: this.$t("customSetting.tktTex"), width: "40px" },
        { field: "defaultAllowance", title: this.$t("customSetting.allowance") + " %", width: "50px" },
        { field: "creationTime", title: this.$t("customSetting.dateCreated"), width: "50px" },
        { field: "createdBy", title: this.$t("customSetting.createdBy"), width: "50px" },
        { field: "lastModificationTime", title: this.$t("customSetting.lastEdited"), width: "50px" },
        { field: "lastModifiedBy", title: this.$t("customSetting.editedBy"), width: "50px" }
      ],
      toast: null as any,
      dataSource: null as any
    };
  },
  created(): any {
    this.toast = useToast();
    this.onMountAdminSettings();
    this.getSettingsGridData();
  },
  methods: {
    handleEditSave() {
      this.showEditPopup = false;
    },
    handleSave() {
      this.showCreatePopup = false;
    },
    onChange() {
      this.$emit("onToggleChange", this.toggleButtonVal);
    },
    loadGrid(): void {
      this.getSettingsGridData();
    },
    showAddCustomSetting(): void {
      this.showCreatePopup = true;
      this.duplicateCustomSettingId = 0;
    },
    async getSettingsGridData(): Promise<void> {
      this.loadingGrid = true;
      await this.customSettingsApi.apiGetCustomSettingsGet().then(res => {
        for (let item of res.data) {
          if (item.name == "Default") {
            item.creationTime = "";
          } else {
            item.creationTime = item.creationTime?.toString().split("T")?.[0];
            item.lastModificationTime = item.lastModificationTime?.toString().split("T")?.[0];
          }
        }
        this.customSettingData = res.data;
        this.dataSource = {
          data: this.customSettingData,
          schema: {
            model: {
              id: "id"
            }
          }
        };
      });
      this.loadingGrid = false;
    },
    onMountAdminSettings(): void {
      if (this.toggleButtonVal) {
        this.customSettingToggleValue = this.enable;
        this.showButtons = true;
        this.columns = this.columns1;
      } else {
        this.customSettingToggleValue = this.disable;
        this.showButtons = false;
        this.columns = this.columns2;
      }
    },
    async onToggleChange(value: boolean): Promise<void> {
      sessionStorage.setItem("customSettingToggleValue", value as unknown as string);
      this.toggleButtonVal = value;
      this.onMountAdminSettings();
      const ConfigurationUpdateDto: ConfigurationUpdateDto = {
        customSettingToggleValue: sessionStorage.getItem("customSettingToggleValue")
      } as ConfigurationUpdateDto;
      await this.userAdminSettingApi
        .apiUpdateSystemConfigurationPost(ConfigurationUpdateDto)
        .then(() => {
          this.toast.success(this.$t("customSetting.customSettingConfigurationUpdated") as string, {
            toastClassName: "custom-success-toast",
            timeout: 5000
          });
        })
        .catch(e => {
          this.toast.error(e.errorMsg, {
            toastClassName: "custom-error-toast",
            timeout: 5000
          });
        });
    },
    editStyle(event: Event): void {
      const target = event.target as any;
      let grid = (this.$refs["settingGrid"] as any).kendoWidget();
      const row = target.closest("tr");
      this.showEditPopup = true;
      this.customSettingId = grid.dataItem(row).id;
    },
    setNewCustomSetting(value: number): void {
      this.showEditPopup = true;
      this.customSettingId = value;
      this.showCreatePopup = false;
    },
    duplicateStyle(event: Event): void {
      const target = event.target as any;
      let grid = (this.$refs["settingGrid"] as any).kendoWidget();
      const row = target.closest("tr");
      const customSettingId = grid.dataItem(row).id;
      if (customSettingId == 0) {
        this.toast.error(this.$t("customSetting.defaultSettingCanNotBeCloned") as string, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      } else {
        this.showCreatePopup = true;
        this.duplicateCustomSettingId = customSettingId;
      }
    },
    async deleteStyle(event: Event): Promise<void> {
      const target = event.target as any;
      let grid = (this.$refs["settingGrid"] as any).kendoWidget();
      const row = target.closest("tr");
      const customSettingId = grid.dataItem(row).id;
      if (customSettingId > 0) {
        const modalcontent = (this.$t("customSetting.deleteWarninig") as string) + " " + grid.dataItem(row).name + " ?";
        try {
          const value: boolean = await this.confirmModal(this.$t("customSetting.confrim") as string, modalcontent);
          if (value) {
            await this.customSettingsApi
              .apiDeleteCustomSettingsByIdDelete(customSettingId)
              .then(async res => {
                if (res.data) {
                  this.toast.success(this.$t("customSetting.success") as string, {
                    toastClassName: "custom-success-toast",
                    timeout: 5000
                  });
                  this.loadGrid();
                } else {
                  this.toast.error(this.$t("customSetting.settingIsAlreadyUsed") as string, {
                    toastClassName: "custom-error-toast",
                    timeout: 5000
                  });
                }
              })
              .catch(e => {
                this.toast.error(e.errorMsg, {
                  toastClassName: "custom-error-toast",
                  timeout: 5000
                });
              });
          }
        } catch (err: any) {
          this.toast.error(err.errorMsg, {
            toastClassName: "custom-error-toast",
            timeout: 5000
          });
        }
      } else {
        this.toast.error(this.$t("customSetting.defaultSettingCanNotBeDeleted") as string, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      }
    }
  }
});
</script>

<style>
.toggleComp {
  width: 99%;
  display: flex;
  justify-content: end;
  align-items: center;
}
.toggle {
  padding-top: 8px;
}
.inputs {
  clear: both;
}
</style>
